import DuckEntity from './DuckEntity'
import {entity as paymentVerifications} from './paymentVerifications';
import DuckEntityForm from './DuckEntityForm';

const entity = new DuckEntity('paymentProfiles', {
  schemaDefinition: {
    payment_verification: paymentVerifications.schema
  }
});

export const paymentProfileForm = new DuckEntityForm('paymentProfileForm', entity);

const reducer = entity.reducer;
export {reducer as default, entity};
